var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import styled, { keyframes } from 'styled-components';
const slide = keyframes `
0% {background-position: 0% 50%;}
50% {background-position: 100% 50%;}
100% {background-position: 0% 50%;}
`;
const ProgressBarContainerStyle = styled.div `
    display: block;
    margin: ${props => props.noMargin ? '0rem' : props.theme.paddingsMargins.themeMenuMargin};
    width: auto;
    border-radius: 10px;
    background: ${props => props.theme.boxes.progresBackground};
    height: ${props => props.height};
    box-shadow: inset 0 0 1px #BEBEBE;
  }
`;
const ProgressBarStyle = styled.div `
  height: 100%;
  width: ${props => props.progress + '%'};
  border-radius: 10px;
  background: ${props => `linear-gradient(90deg, ${props.theme.utils.getColor(props.color)}, ${props.theme.utils.getColorDark(props.color)})`};
  background-size: 200% 200%;
  animation: ${slide} 4s ease infinite;
  transition: width 1s
`;
const ProgressBar = (_a) => {
    var { height = '10px', color = 'main', progress = 0, noMargin = false } = _a, props = __rest(_a, ["height", "color", "progress", "noMargin"]);
    const percentageLimits = (min, max, value) => {
        return Math.min(Math.max(min, value), max);
    };
    return (_jsx(ProgressBarContainerStyle, Object.assign({ height: height, noMargin: noMargin }, props, { children: _jsx(ProgressBarStyle, { progress: percentageLimits(0, 100, progress), color: color }) })));
};
export default ProgressBar;
